// tslint:disable:no-any
import jwtDecode from 'jwt-decode';

import { ChangePasswordDTO, ProfileApiFactory, UserBasicInfoDTO, UserSettingsDTO } from '../api';
import { AuthLogic } from '../auth/AuthLogic';
import { UserNotificationStore } from '../components/UserNotifications/UserNotificationStore';
import { ISettings, SettingsService } from './SettingsService';

// import history from '../auth/History';
export class ProfileService {
    public static instance: ProfileService;
    public static getInstance(): ProfileService {
        if (ProfileService.instance == undefined) {
            ProfileService.instance = new ProfileService();
        }

        return ProfileService.instance;
    }

    public async updateProfilePassword(data: ChangePasswordDTO) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await ProfileApiFactory({
                accessToken: token
            }).apiProfileChangePasswordPost(data);

            await this.reloadProfile();
            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async updateProfileSettings(settings: UserSettingsDTO) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await ProfileApiFactory({
                accessToken: token
            }).apiProfileSettingsPut(settings);

            await this.reloadProfile();
            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async updateProfilePersonalData(info: UserBasicInfoDTO) {
        try {
            const token = await AuthLogic.getInstance().getToken();
            if (token == undefined) {
                return undefined;
            }

            const response = await ProfileApiFactory({
                accessToken: token
            }).apiProfileBasicInfoPut(info);

            await this.reloadProfile();
            return response;
        } catch (e) {
            const response = e as Response;
            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            return response;
        }
    }

    public async reloadProfile(): Promise<ISettings | undefined | Response> {
        try {
            const token = await AuthLogic.getInstance().getToken();
            let idToken = AuthLogic.getInstance().getIdToken();

            if (token != undefined) {
                const profile = await ProfileApiFactory({
                    accessToken: token
                }).apiProfileGet();

                if (
                    profile == undefined ||
                    profile.userBasicInfo == undefined
                ) {
                    return undefined;
                }

                let idJwtPayloadToken = null;
                if (idToken != undefined) {
                    idJwtPayloadToken = jwtDecode(idToken) as any;
                }

                const result: ISettings = {
                    canChangePassword:
                        idJwtPayloadToken != undefined
                            ? idJwtPayloadToken[
                                  'https://wetnotes.com/api/canChangePassword'
                              ] === true
                            : false,
                    picture:
                        idJwtPayloadToken != null
                            ? idJwtPayloadToken.picture
                            : null,
                    nickname: profile.userBasicInfo.nickname,
                    contactEmail: profile.userBasicInfo.contactEmail,
                    dateRegistered: profile.userBasicInfo.dateRegistered,
                    emailVerified: idJwtPayloadToken.email_verified,
                    name: profile.userBasicInfo.name,
                    surname: profile.userBasicInfo.surname,
                    config: profile.userSettings
                };

                SettingsService.getInstance().setSettings(result);
                UserNotificationStore.getInstance().refreshNotifications();
                return result;
            }
        } catch (e) {
            const response = e as Response;
            if (response == undefined) {
                // tslint:disable-next-line:no-console
                console.log(
                    'Error happened while reloading profile but response is undefined'
                );

                return undefined;
            }

            if (response.status === 401 || response.status === 403) {
                AuthLogic.getInstance().logout();
            }

            /*const data = (await response.json()) as GeneralError;
            if (data != undefined) {
                if (data.errorText == 'NotRegistered') {
                    // history.replace('/?NotRegistered');
                }
            }*/

            return response;
        }

        return undefined;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/ProfileService.ts